import { FiltersOptions } from '@lidea/shared/util/types';
import { IconChevronDown } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './filter.module.css';

type Values = FiltersOptions[keyof FiltersOptions];

export type FilterProps = Values & {
  selected: number;
  onClick: () => void;
};

export const Filter = ({ label, value, selected, onClick }: FilterProps) => {
  const { t } = useTranslation(['plot'], { useSuspense: false });

  return (
    <button
      className={styles.filterCard}
      data-testid={value}
      type="button"
      onClick={onClick}
    >
      <span className={styles.filterLabel}>{t(`plot:${label}`)}</span>
      {selected > 0 ? (
        <span className={styles.filterBadge}>{selected}</span>
      ) : (
        <IconChevronDown className={styles.filterChevron} size={20} stroke={1.75} />
      )}
    </button>
  );
};
